// extracted by mini-css-extract-plugin
module.exports = {"ticket":"fk4Lh","name":"_21xG_","tax":"_32HS1","inner":"_35emb","quantity":"_2M3fP","price":"_3xqdc","soldOut":"_2mB-5","description":"_36z93","divider":"zB4V0","tooltip":"BUY8s"};